import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { FAQS } from "../lib/data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  return (
    <div>
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 py-16">
        <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-3">Support</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#0A1914] mb-3">Frequently Asked Questions</h1>
        <p className="text-gray-600 mb-10">Everything you need to know about our courses, payouts and company.</p>
        <Accordion type="single" collapsible className="border-t border-gray-200">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-gray-200" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-semibold text-[#0A1914] hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed text-[15px]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <Footer />
    </div>
  );
}
